<!--新闻管理-->
<template>
  <div class="container" style="min-width: 900px">
    <p style="font-size:26px;display: inline-block;cursor:pointer">官网新闻</p>
    <div class="formStyle">
      <p class="formTitle">新闻信息填写</p>
      <Form :model="formItem" :label-width="100" style="padding:20px">
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">图片上传</Col>
            <Col span="15">
            <Upload multiple type="drag"
                    action="/zm/cos/upload"
                    :on-success="uploadSuccess">
              <div style="padding: 20px 20px">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>Click or drag images here to upload</p>
              </div>
            </Upload>
            </Col>
          </Row>
        </formItem><!--图片上传-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">上传地址</Col>
            <Col span="15">
            <ul>
              <li v-for="(value,index) in imgPath" style="font-size: 1rem">
                <span style="color: dodgerblue">{{value.name}}</span>&emsp;{{value.path}}
                <Button type="primary" size="small" @click="copyTo(value.path)">将该地址复制到图片地址中</Button>
              </li>
            </ul>
            </Col>
          </Row>
        </formItem><!--图片地址-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">封面图预览</Col>
            <Col span="15">
              <img :src="formItem.titleImgUrl" style="width: 150px; height:150px">
            </Col>
          </Row>
        </formItem><!--封面图-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">封面图地址</Col>
            <Col span="15">
              <Input v-model="formItem.titleImgUrl"></Input>
            </Col>
          </Row>
        </formItem><!--主标题-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">主标题</Col>
            <Col span="15">
            <Input v-model="formItem.mainTitle" placeholder="请输入主标题..."></Input>
            </Col>
          </Row>
        </formItem><!--主标题-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">来源</Col>
            <Col span="15">
            <Input v-model="formItem.source" placeholder="请输入来源..."></Input>
            </Col>
          </Row>
        </formItem><!--来源-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">新闻类别</Col>
            <Col span="15">
              <RadioGroup v-model="formItem.newsCategory">
                <Radio label="1">公司新闻</Radio>
                <Radio label="2">行业动态</Radio>
                <Radio label="3">媒体报导</Radio>
              </RadioGroup>
            </Col>
          </Row>
        </formItem><!--类别-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">发布时间</Col>
            <Col span="5">
            <DatePicker type="datetime"
                        placeholder="Select date"
                        v-model="formItem.time"
                        format="yyyy-MM-dd HH:mm">
            </DatePicker>
            </Col>
            <!--<Col span="2">——</Col>-->
            <!--<Col span="5">-->
            <!--<TimePicker type="time" placeholder="Select time" v-model="formItem.publicTime"></TimePicker>-->
            <!--</Col>-->
          </Row>
        </formItem><!--发布时间-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">简介</Col>
            <Col span="15">
            <Input v-model="formItem.summary" placeholder="请输入简介..."></Input>
            </Col>
          </Row>
        </formItem><!--副标题-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">详细内容</Col>
            <Col span="15">
            <Input v-model="formItem.content" type="textarea"
                   :autosize="{minRows: 4,maxRows: 8}"
                   placeholder="请输入详细内容..."></Input>
            </Col>
          </Row>
        </formItem><!--副标题-->
        <formItem style="text-align: center">
          <Button v-if="isNew" type="primary" @click="submitTotal">添加新闻</Button>
          <Button v-else type="primary" @click="saveChange">提交修改</Button>
        </formItem>
      </Form>
    </div>

  </div>
</template>

<script>
  import {format2Sec} from "../../utils/format";
  import {adminRouter} from "../../router/admin";

  export default {
    name: "editNewsInfo",
    data(){
      return{
        formItem:{},
        imgPath:[], //上传的图片地址
        isNew: true
      };
    },
    methods:{
        copyTo(value){
            this.formItem.titleImgUrl = value;
        },
        showNewsInfo(id){
            let active = 'newsInfo';
            let currentTag = localStorage.getItem('currentTag');
            if (currentTag !== active){
                let tags = null;
                for (let ele of adminRouter){
                    if (ele.name === active){
                        tags = {
                            title: ele.title,
                            name: ele.name,
                            path: ele.path
                        };
                        break;
                    } else {
                        if (ele.children.length){
                            for (let val of ele.children){
                                if (val.name === active){
                                    tags = {
                                        title: val.title,
                                        name: val.name,
                                        path: val.path
                                    };
                                    break;
                                }
                            }
                        }
                    }
                }
                localStorage.setItem("currentTag", active);
                localStorage.setItem("newsId", id);
                this.$store.commit("updateCurrentTag", active);
                this.$store.commit("updateOpenedTags", [tags]);
                this.$store.commit("updateCurrentPath", active);
                this.$router.push({
                    name: active
                });
            }
        },
        backToList(){
            let active = 'newsManager';
            let currentTag = localStorage.getItem('currentTag');
            if (currentTag !== active){
                let tags = null;
                for (let ele of adminRouter){
                    if (ele.name === active){
                        tags = {
                            title: ele.title,
                            name: ele.name,
                            path: ele.path
                        };
                        break;
                    } else {
                        if (ele.children.length){
                            for (let val of ele.children){
                                if (val.name === active){
                                    tags = {
                                        title: val.title,
                                        name: val.name,
                                        path: val.path
                                    };
                                    break;
                                }
                            }
                        }
                    }
                }
                localStorage.setItem("currentTag", active);
                this.$store.commit("updateCurrentTag", active);
                this.$store.commit("updateOpenedTags", [tags]);
                this.$store.commit("updateCurrentPath", active);
                this.$router.push({
                    name: active
                });
            }
        },
      uploadSuccess(res, file){
        this.imgPath.push({name:file.name, path:res.content});
      }, //获取图像地址
      submitTotal(){
          this.formItem.publicDate = this.formItem.time.getTime();
          delete this.formItem.time;
          this.$http.post('/zm/WMWebsite/addNewsInfo', this.formItem).then(res => {
              this.$Message.success("上传成功！");
              this.backToList();
              this.formItem={
                  titleImgUrl:"", //封面图
                  mainTitle:"", //主标题
                  source:"", //文章来源
                  publicDate:"", //发布日期
                  summary:"", //文章简介
                  content:""//文章内容
                };
                this.imgPath=[];
         }, err => {
           this.$Message.error("上传失败！"+err.message);
          });
        }, //上传
        saveChange(){
            this.formItem.publicDate = this.formItem.time.getTime();
            let id = this.formItem.id;
            delete this.formItem.time;
            this.$http.post('/zm/WMWebsite/updateNewsInfos', this.formItem).then(
                res => {
                    this.$Message.success("提交成功！");
                    this.showNewsInfo(id);
                    this.formItem={
                        titleImgUrl: '填入上传地址中的Url'
                    };
                    this.imgPath=[];
                },
                err => {
                    this.$Message.error("提交失败！"+err.message);
                }
            );
        }
      },

      activated() {
          let id = localStorage.getItem('newsId');
          if (id !== ''){
              this.isNew = false;
              this.$http.get('/zm/WMWebsite/queryNewsInfos').then(
                  res => {
                      let tempList = res.data.content;
                      tempList.forEach((item) => {
                          if (item.id === Number(id)){
                              this.formItem = item;
                              this.formItem.time = format2Sec(this.formItem.publicDate);
                              this.formItem.newsCategory = String(this.formItem.newsCategory);
                          }
                      });
                  }
              );
          }else {
              this.isNew = true;
              this.formItem={
                  titleImgUrl: '填入上传地址中的Url',
              };
          }
      }
  };
</script>

<style scoped>
  .container {
    padding: 0;
    margin: 20px 0 0 25px;
  }  /*全局配置*/
  .formStyle{
    background-color: #fff;
    margin:2% auto;
    width: 96%;
    border-radius: 5px;
  }  /*表单外观设置*/
  .formTitle{
    font-size: 20px;
    font-family: "黑体";
    padding:15px;
    text-align: center;
  }  /*表单标题*/
  .formItemTitle{
    font-size: 18px;
  }  /*表单项目标题*/
</style>



// WEBPACK FOOTER //
// editNewsInfo.vue?17e6436b